import request from "@/http/axios";

export function startQa() {
  return request({
    url: "/telmonitor/conf/startQa",
    method: "POST",
    data: {}
  });
}

export function stopQa() {
  return request({
    url: "/telmonitor/conf/stopQa",
    method: "POST",
    data: {}
  });
}

export function promoteQa(partyId) {
  return request({
    url: "/telmonitor/conf/promoteQa",
    method: "POST",
    data: {
      partyId
    }
  });
}

export function stopQaTalking() {
  return request({
    url: "/telmonitor/conf/stopQaTalking",
    method: "POST",
    data: {}
  });
}

export function removeQa(partyId) {
  return request({
    url: "/telmonitor/conf/removeQa",
    method: "POST",
    data: {
      partyId
    }
  });
}

export function moveUpQa(partyId) {
  return request({
    url: "/telmonitor/conf/moveUpQa",
    method: "POST",
    data: {
      partyId
    }
  });
}

export function moveTopQa(partyId) {
  return request({
    url: "/telmonitor/conf/moveTopQa",
    method: "POST",
    data: {
      partyId
    }
  });
}

export function qaList() {
  return request({
    url: "/telmonitor/conf/queryQaList",
    method: "POST",
    data: {}
  });
}

export function qaFloorId() {
  return request({
    url: "/telmonitor/conf/getQAFloorPartyID",
    method: "POST",
    data: {}
  });
}
